import { useEffect, useState } from "react";

interface Props {
  anchorId: string | null;
}

export function JumpToNowButton({ anchorId }: Props) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!anchorId) {
      setVisible(false);
      return;
    }
    const el = document.getElementById(anchorId);
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => setVisible(!entry?.isIntersecting),
      { threshold: 0.1 },
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [anchorId]);

  if (!visible || !anchorId) return null;

  return (
    <button
      type="button"
      onClick={() => {
        const el = document.getElementById(anchorId);
        el?.scrollIntoView({ block: "center", behavior: "smooth" });
      }}
      className="fixed left-1/2 -translate-x-1/2 z-30 bg-slate-900 text-white px-4 py-2.5 rounded-full shadow-lg text-sm font-medium active:scale-95 transition"
      style={{ bottom: "calc(1.5rem + env(safe-area-inset-bottom))" }}
    >
      지금으로 이동
    </button>
  );
}
